
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import { isNLW, isPMDB } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';

export const getGrantingForApp = ({ user, field, grantingField }) => {
    if (field === CustomTypes.STATUS && isNLW()) {
        if (grantingField === "awaiting_approval") {
            if (user && user.role && (user.role === CustomTypes.ROLE_LEVEL5 || user.role === CustomTypes.ROLE_LEVEL6
                || user.role === CustomTypes.ROLE_LEVEL7 || user.role === CustomTypes.ROLE_LEVEL8))
                return true;
            else
                return false;
        }
        return true;
    }
    return true;
}


export const checkGranting = (field, userrole) => {
    if (isPMDB()) {
        if (field === CustomTypes.STATUS && (userrole && (userrole === CustomTypes.ROLE_LEVEL0
            || userrole === CustomTypes.ROLE_LEVEL1)))
            return false;
    } else {
        if (field === CustomTypes.STATUS && (userrole && (userrole === CustomTypes.ROLE_LEVEL0
            || userrole === CustomTypes.ROLE_LEVEL1 || userrole === CustomTypes.ROLE_LEVEL2)))
            return false;
    }
    return true;
}

export const checkStatus = ({ user, field, checkField }) => {
    if (field === CustomTypes.STATUS && isNLW()) {
        if (checkField === "internal_material") {
            if (user && user.role && (user.role === CustomTypes.ROLE_LEVEL5 || user.role === CustomTypes.ROLE_LEVEL6
                || user.role === CustomTypes.ROLE_LEVEL7 || user.role === CustomTypes.ROLE_LEVEL8)) {
                return true;
            }
            else
                return false;
        }
        return true;
    }
    return true;
}
